// Chakra Imports
import { SlideFade } from '@chakra-ui/react';

// Custom components
import { ParameterInfo } from './ParameterInfo';
import type { PremiseLayout } from './premiseDisplayUtils';

export type InputPremise = {
  id: number
  name: string;
  description: string;
  origin: string;
  lastUpdate: Date | null;
  lastModifiedBy: string;
  value: any | null;
  itemCount: bigint | null;
  downloadable: boolean;
  summarizingString: string;
  displayIcon: string;
  isConfigurable: boolean;
  type: string
};

export const InputParameter = (props: {
  premise: InputPremise;
  layout?: PremiseLayout;
  [x: string]: any;
}) => {
  const { premise, index, reloader, productOptions, layout = "card" } = props;
  const motionOffset = layout === "list" ? "12px" : index % 2 === 0 ? "30px" : "-30px";
  return (
    <SlideFade
      in={true}
      offsetY={motionOffset}
      delay={layout === "list" ? index * 0.04 : index / 4}
    >
      <ParameterInfo
        gridArea={{ base: "2 / 2 / 2 / 2", lg: "2 / 2 / 2 / 2" }}
        premise={premise}
        reloader={reloader}
        layout={layout}
        productOptions={productOptions}
      />
    </SlideFade>
  );
};
